import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./gateway-dashboard-search-directive.html';
import styles from './gateway-dashboard-search-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(template, styles);

export default [function () {
    return {
        restrict: 'EA',
        template: hashedTemplate,
        scope: {},
        controller: ['$scope', 'SearchService', 'ViewModelService', function ($scope, SearchService, ViewModelService) {
            var CARRIAGE_RETURN = 13;

            $scope.searchResults = {};
            $scope.searchComplete = false;
            $scope.search = {
                searchParam: '',
                previousSearchParam: ''
            };

            $scope.wipe = function () {
                $scope.search.searchParam = '';
            };

            $scope.textInputCallback = function ($event) {
                if ($event.which === CARRIAGE_RETURN) {
                    $scope.performSearch($scope.search);
                }
            };

            $scope.searchRequestView = ViewModelService.create($scope.search, 'pc', 'edge.capabilities.gateway.search.dto.SearchRequestDTO');

            $scope.performSearch = function (search) {
                if (search.searchParam.length > 0) {
                    $scope.searchPromise = SearchService.search(search);
                    $scope.searchPromise.then(function (result) {
                        $scope.search.previousSearchParam = $scope.search.searchParam;
                        $scope.searchResults.accounts = result.accounts.filter(function (account) {
                            return account != null;
                        }).map(mapAccount);
                        $scope.searchResults.policies = result.policies.filter(function (policy) {
                            return policy.policyNumber;
                        }).map(mapPolicy);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            };

            var mapAccount = function mapAccount(account) {
                return {
                    accountNumber: account.accountNumber,
                    accountName: account.accountHolder,
                    primaryAddress: account.accountHolderAddress
                };
            };

            var mapPolicy = function mapPolicy(policy) {
                return {
                    account: {
                        accountNumber: policy.accountNumber,
                        accountName: policy.accountHolder.subtype === 'Company' ? policy.accountHolder.contactName : policy.accountHolder.firstName + ' ' + policy.accountHolder.lastName,
                        primaryAddress: policy.accountHolder.primaryAddress
                    },
                    linesOfBusiness: policy.policyLines.map(function (line) {
                        return line.lineOfBusiness;
                    }),
                    policyNumber: policy.policyNumber,
                    producerCode: policy.producerCodeOfService
                };
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/GatewayDashboardSearchDirective/GatewayDashboardSearchDirective.js
// module id = 1744
// module chunks = 0